import React, {useCallback, useEffect, useMemo, useState} from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import {QUOTE_ITEM, QUOTE_ITEM_FORM} from "v4/data/apiRoutes";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import ProspectQuotesRecalculateButton
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesRecalculateButton/ProspectQuotesRecalculateButton";
import ProspectWonQuotesTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectWonQuotesTab/components/ProspectWonQuotesTabListing/ProspectWonQuotesTabListing";
import ProspectWonQuoteTabShow
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectWonQuotesTab/components/ProspectWonQuoteTabShow/ProspectWonQuoteTabShow";
import {
    whenSubmitted
} from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesTab/ProspectQuotesTab";

export default function ProspectWonQuotesTab() {
    const { currentRoute } = useNavigation();
    const isShow = currentRoute.routeType === 'SHOW';
    const isEdit = currentRoute.routeType === 'EDIT';
    const isListing = currentRoute.routeType === 'LISTING';

    const { prospect: prospectId, quote: showId } = currentRoute.params;
    const [quoteData, setQuoteData] = useState(null);

    const onGetData = useCallback((data) => {
        const hydraMember = (typeof data === 'function' ? data(quoteData) : data?.['hydra:member']) ?? data;
        setQuoteData(hydraMember);
    }, [quoteData]);

    useEffect(() => {
        quoteData && onGetData(quoteData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quoteData]);

    const fetchFormParameters = useMemo(() => ({
        id: showId,
        prospectId
    }), [showId, prospectId]);

    return (
        <>
            <ToggleComponent isShowing={isListing}>
                <ProspectWonQuotesTabListing prospectId={prospectId}/>
            </ToggleComponent>

            <ToggleComponent isShowing={isShow && !isEdit} shouldRemoveFromDom={true}
                             className="prospect-tab__prospect showing">
                <ProspectWonQuoteTabShow prospectId={prospectId}
                                         showId={showId}
                                         onGetData={onGetData}
                                         quoteData={quoteData}
                                         setQuoteData={setQuoteData}/>
            </ToggleComponent>

            <ToggleComponent isShowing={isEdit} shouldRemoveFromDom={true} className="prospect-tab__prospect editing">
                <FormEntityLayout title="affaires"
                                  action="edit"
                                  formRouteName={QUOTE_ITEM_FORM}
                                  submitRouteName={QUOTE_ITEM}
                                  fetchFormParameters={fetchFormParameters}
                                  onGetData={onGetData}
                                  additionalButtons={() => (
                                      <ProspectQuotesRecalculateButton eventForRecalculate={`beforesave:${QUOTE_ITEM}`}/>
                                  )}
                                  whenSubmitted={whenSubmitted}/>
            </ToggleComponent>
        </>
    )
}
